export const businessLines = {
  banks: 'Banks',
  corporates: 'Corporates',
  sovereigns: 'Sovereigns',
  'sub-sovereigns': 'Sub-Sovereigns',
  supranationals: 'Supranationals',
};
